import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Input = _resolveComponent("Input")
  const _component_Collapse = _resolveComponent("Collapse")

  return (_openBlock(), _createElementBlock("div", {
    class: "search-input",
    onMouseenter: _cache[3] || (_cache[3] = (...args) => ($options.onMouseEnter && $options.onMouseEnter(...args))),
    onMouseleave: _cache[4] || (_cache[4] = (...args) => ($options.onMouseLeave && $options.onMouseLeave(...args)))
  }, [
    _createElementVNode("div", {
      class: "row-hvcenter pointer open-icon",
      disabled: $props.disabled
    }, [
      _createVNode(_component_Icon, {
        icon: "search",
        stroke: "var(--gray-700)",
        width: "2rem",
        height: "3.2rem"
      })
    ], 8 /* PROPS */, _hoisted_1),
    _createVNode(_component_Collapse, {
      open: $options.c_show,
      horizontal: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Input, {
          ref: "search",
          modelValue: $data.search,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.search) = $event)),
          minlength: $props.minlength,
          maxlength: 100,
          placeholder: $props.placeholder,
          disabled: $props.disabled,
          style: _normalizeStyle({width: $props.width}),
          class: "search",
          type: "text",
          spellcheck: false,
          footer: false,
          onBlur: _cache[2] || (_cache[2] = $event => ($data.do_blur()))
        }, {
          custom_icon: _withCtx(({disabled: icon_disabled}) => [
            ($props.loading)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 0,
                  class: "pointer",
                  style: {"position":"static"},
                  inline: "",
                  mini: ""
                }))
              : ($data.search)
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 1,
                    class: "pointer",
                    width: "1.6rem",
                    height: "1.6rem",
                    icon: "x-close",
                    disabled: icon_disabled,
                    onClick: _cache[0] || (_cache[0] = $event => ($options.onClean()))
                  }, null, 8 /* PROPS */, ["disabled"]))
                : (!$props.alwaysShow)
                  ? (_openBlock(), _createBlock(_component_Icon, {
                      key: 2,
                      width: "1.4rem",
                      height: "1.4rem",
                      "stroke-width": "0.1",
                      icon: "enter",
                      stroke: "var(--gray-500)",
                      disabled: icon_disabled
                    }, null, 8 /* PROPS */, ["disabled"]))
                  : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "minlength", "placeholder", "disabled", "style"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["open"])
  ], 32 /* NEED_HYDRATION */))
}